
<template>

    
    <div class="Tab" ref="Tab">
         <BlockPagingAnchor PagingBlockSelector=".Tab"
                           ItemListContainerSelector=".TabPageItemListContainer"
                           ItemListSelector=".TabPageItemList"
                           ItemSelector=".TabPageItem"
                           HoverToPicture="false"
                           ShowPagingButton="true"
                            ShowPaginationButton="false"
                           :TargetList="TabPageItems"
 
                           ItemPerPage="4"
                           PlayMode="Normal"
                            
                           ref="BlockPagingAnchor"
                           v-model="PageIndex" />
         
        <div class="TabPageItemListContainer">
            <div class="TabPageItemList">
                <div class="TabPageItem" v-for="(item,index) in TabPageItems"
                     @click="OnTabPageItemClick(index)"
                     
                     :class="{'Hide':item.Visible==false||item.Visible=='false'}"
                     > 
                    <span v-html="item.Text"></span>
                </div>
            </div>
        </div>
       
        <div class="TabPageContentList">
            <slot></slot>

        </div>
    </div>



</template>

<script scoped>
    import Utility from '@/Common/Utility';
    import apiService from '@/Common/ApiService';
    import PlugableControlBase from "@/Common/PlugableControlBase";
    import eventBus from '@/Common/EventBus';
    import BlockPagingAnchor from '@/PlugableControls/BlockPagingAnchor'
    import ChildDraggableBase from '@/Common/ChildDraggableBase'

    export default {
        name: "Tab",
        data() {
            return {

                PageIndex : 0,
                TabPageItems:[],
            }
        }
        ,

        props: [],

        methods: {

            OnPageIndexChange() {
                debugger;
                this.SetFocusPage(this.PageIndex);
            },

            ResetVisibility() {
                let pageElements;
                let i;


                pageElements = this.$el.querySelectorAll("Page");

                for (i = 0; i < pageElements.length; i++) {
                    let pageItem = this.TabPageItems[i];

                    if (pageElements[i].getAttribute("visible") == false ||
                        pageElements[i].getAttribute("visible") == "false"
                    ) {
                        pageItem.Visible = false;
                    }
                    else {
                        pageItem.Visible = true;
                    }
                }

                this.$forceUpdate();

            },

            OnTabPageItemClick(index) {
                this.SetFocusPage(index);
                 
                this.$emit(
                    "PageChange",
                    this,
                    index
                );
            } ,

            SetFocusPage(index) {
                let itemElements,contentElements;
                let i;

                itemElements = this.$el.querySelectorAll(":scope > .TabPageItemListContainer > .TabPageItemList > .TabPageItem");


                for (i = 0; i < itemElements.length; i++) {
                    itemElements[i].classList.remove("Focus");
                    if (i == index) {
                        itemElements[i].classList.add("Focus");
                    }
                }

                contentElements = this.$el.querySelectorAll(":scope > .TabPageContentList > DIV , :scope > .TabPageContentList > PAGE");

                for (i = 0; i < contentElements.length; i++) {

                  
                    if (i == index) {
                        contentElements[i].style.display = "block";
                    }
                    else {
                        contentElements[i].style.display = "none";
                    }
                }
            },

            
      
     
     


        },

        beforeMount() {
        },

        created: function () {
        },


        mounted: function () {
            let pageElements;
            let i;

            pageElements = this.$el.querySelectorAll("Page");


            for (i = 0; i < pageElements.length; i++) {
                let text;
                let pageItem = {};

                text = pageElements[i].getAttribute("Text");

                if (!pageElements[i].classList.contains("TabPageContent")) {
                    pageElements[i].classList.add("TabPageContent");
                }

                pageItem.Text = text;
                
                 
                if (pageElements[i].getAttribute("visible") == false ||
                    pageElements[i].getAttribute("visible") == "false"
                ) {
                    pageItem.Visible = false;
                }
                else {
                    pageItem.Visible = true;
                }



                this.TabPageItems.push(pageItem);

            }

            setTimeout(
                () => {
                    this.SetFocusPage(0);
                },
                10
            );

            setTimeout(
                () => {
                    this.SetFocusPage(0);
                },
                100
            );

        },

        beforeMounted() {

        },

        beforeDestroy() { 
        },

        components: {
            BlockPagingAnchor: BlockPagingAnchor,

        },


        computed: {

        },

        watch: {

            Rows(newVal) {
             },

            PagingData(newVal) {
 
            },

            '$route'(to, from) {

                // Put your logic here...
            }

        },

        beforeRouteLeave(to, from, next) {

            next();
        }


    }
</script>

<style>
    
</style>
<style scoped>
    .Tab {
        position:relative; 
    }

    .TabPageItemListContainer { 
 
    }

    .TabPageItemList  { 
        max-width: 100%;
    }

        .TabPageItemList .TabPageItem.Hide{
            display:none!important;
        }

        .TabPageItem {
            height: 40px;
        }

    @media screen and (max-width:660px){
        /deep/ .PagingButton {
            position: absolute;
            top: -5px;
            z-index: 10;
            width: 20px;
            height: 30px;
            padding-top: 8px;
            cursor: pointer;
        }

            /deep/ .PagingButton.Disabled {
                opacity: 0.4;
                cursor: default;
            }

            /deep/ .PagingButton.Previous {
                left: 0px;
            }

                /deep/ .PagingButton.Previous:before {
                    content: "🞀";
                    font-size: 20px;
                }


            /deep/ .PagingButton.Next {
                right: 0px;
            }

                /deep/ .PagingButton.Next:before {
                    content: "🞂";
                    font-size: 20px;
                }

        .TabPageItemList .TabPageItem {
            border-bottom:none;
        }

        .TabPageItemList
        {
            border-bottom:none;
        }

    }


    .PaginationButtonList {
        display: none;
    }
</style>
